import { flow, tap } from '@helo/utils'

import { NotificationItemResponse } from '../../../components/Notifications/NotificationsMenu'
import { NotificationsSlice } from './notificationSlice'

const setNotifications = (notifications: NotificationItemResponse[]) =>
  flow(
    flow.inputExtends<NotificationsSlice>(),
    <T extends NotificationsSlice>(store: T): T => ({
      ...store,
      notifications: {
        ...store.notifications,
        notifications,
      },
    }),
  )

const shouldShouldFastPoll = () => (store: NotificationsSlice) =>
  store.notifications.pollingSpeed === 'fast' &&
  store.notifications.pollingCount < 30

const incrementPollingCount = () =>
  flow(
    flow.inputExtends<NotificationsSlice>(),
    <T extends NotificationsSlice>(store: T): T => ({
      ...store,
      notifications: {
        ...store.notifications,
        pollingCount: store.notifications.pollingCount + 1,
      },
    }),
  )

const startTimeout = <T>(
  /**
   * Function to run after the timeout
   */
  fn: (ctx: T) => void,
  /**
   * Function to generate timeout in milliseconds
   *
   */
  ms: ((ctx: T) => number) | number,
) =>
  tap((ctx: T) =>
    setTimeout(() => fn(ctx), typeof ms === 'function' ? ms(ctx) : ms),
  )

export const NotificationSliceParts = {
  setNotifications,
  shouldShouldFastPoll,
  incrementPollingCount,
  startTimeout,
}
